import { gql } from "@apollo/client";

export const GET_SHIPPING_METHODS = gql`
  query shippingMethods {
    shippingMethods {
      title
      description
      id
      price {
        amount
        currency
      }
    }
  }
`;
